const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./page15.jpg"),
			class: "image-one",
			imgdiv: "imageCover",
		},
		{
			src: images("./hen.gif"),
			class: "image-one img11",
			imgdiv: "imageCover",
		},
		{
			src: images("./cycle_rickshaw_r.png"),
			class: "image-one rickshaw",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text page15Text text-center",
			textIndivData: [
				{
					textData: "तर एउटा चल्‍ला भने फरक देखियो।",
					textClass: "m-0",
					timestamps: [{ start: 0 }, { start: 0.7 }, { start: 1.1 }, { start: 1.45 }, { start: 1.8 }, { start: 2.1 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./15.ogg"),
			delay: 500,
		},
		{
			url: audios("./rickshaw.ogg"),
			delay: 500,
			isBg: true,
			volume: 0.1,
			loop: false,
		},
		{
			url: audios("./hen.ogg"),
			delay: 500,
			isBg: true,
			volume: 0.3,
		},
	],
}

export default content
